// extracted by mini-css-extract-plugin
export default {"container":"MoreMenu_container__n5ODw","panel":"MoreMenu_panel__iOp8O","open":"MoreMenu_open__siqQV","arrow":"MoreMenu_arrow__6s3AB","item":"MoreMenu_item__eWwhU"};